import { Chip, Grid, styled } from "@material-ui/core";
import * as React from "react";
import { NumberInput, RadioButtonGroupInput, required, TextInput } from "react-admin";
import { Form } from "react-final-form";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { RequestType } from "../../../../Enums/RequestType";
import { Separator } from "../../../../Components/Separator";
import { PnSelectionChoices, RequestTypeChoices } from "../../Constant/Source";
import { useAuth } from "@airborne/react-admin";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import { HomeWork } from "@material-ui/icons";
import InformationLabel from "../../../../Components/InformationLabel/InformationLabel";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const CustomerRemarkTextInput = styled(TextInput)({
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#c80c0f",
  },
});

const RequestView = props => {
  const { user } = useAuth();

  return (
    <>
      <Form
        initialValues={props.DataSource}
        onSubmit={() => {}}
        render={() => (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <>
                <Separator />
                <Grid {...gridContainerProps}>
                  <SectionTitle label="Contract Info" />
                  <Grid {...gridContainerProps}>
                    <InformationLabel data={props?.DataSource} />
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="contract.contractName"
                      label="Contract"
                      validate={required()}
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={5}>
                    <RadioButtonGroupInput
                      source="requestType"
                      label="Request Type"
                      fullWidth
                      defaultValue={Number(RequestType.RBH)}
                      choices={RequestTypeChoices}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                </Grid>
                <Separator />

                <Grid {...gridContainerProps}>
                  <SectionTitle label="Order Info" />
                </Grid>
                <Grid {...gridContainerProps} alignItems={"flex-start"}>
                  <Grid item xs={12} sm={5}>
                    <RadioButtonGroupInput
                      source="isDefined"
                      label="PN Selection"
                      fullWidth
                      choices={PnSelectionChoices}
                      defaultValue={props.DataSource?.isDefined}
                      variant="outlined"
                      disabled
                    />
                    <TextInput
                      source="customerRequestComponent"
                      label="Part Number"
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput
                      source="componentDescription"
                      label="Component Description"
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextInput source="repairTat" label="Repair Tat" variant="outlined" fullWidth disabled />
                    {user?.isCustomer !== true && (
                      <Chip
                        key={props?.selectedData?.id}
                        size="medium"
                        style={{ color: "#767676", marginTop: 10 }}
                        variant="outlined"
                        label={`In Stock: ${props?.DataSource?.inStock === true ? "Yes" : "No"}`}
                        icon={<HomeWork />}
                      />
                    )}
                  </Grid>

                  <Grid item xs={12} sm={5}>
                    <NumberInput source="chapter" label="Ata Chapter" fullWidth variant="outlined" disabled />
                    <TextInput source="aircraft.acReg" label="Aircraft" fullWidth disabled variant="outlined" />
                    <TextInput source="releaseType" label="Release Type" fullWidth disabled variant="outlined" />
                    <TextInput source="airportCode" label="Airport Code" fullWidth disabled variant="outlined" />
                    <TextInput source="refNo" label="REF NO" variant="outlined" fullWidth disabled />
                    <Grid container spacing={2}>
                      <Grid item xs={8} sm={9}>
                        <TextInput source="customerPo" label="Customer PO/RO" fullWidth variant="outlined" disabled />
                      </Grid>
                      <Grid item xs={4} sm={3}>
                        <TextInput source="customerPoLine" label="Line" variant="outlined" fullWidth disabled />
                      </Grid>
                    </Grid>
                    <CustomerRemarkTextInput
                      source="requestRemark.remark"
                      label="Remarks of Customer"
                      multiline
                      fullWidth
                      rows={3}
                      variant="outlined"
                      disabled
                      FormHelperTextProps={{ style: { display: "block", color: "#c80c0f" } }}
                      helperText="If any, remarks about the order itself should be explained such as ‘Rejection order due to corrosion’"
                    />
                  </Grid>
                </Grid>
                <Separator />

                <Grid {...gridContainerProps}>
                  <SectionTitle label="Delivery To" />
                </Grid>
                <Grid {...gridContainerProps} alignItems={"flex-start"}>
                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="requestDeliveryInfo.attentionName"
                      label="Attention Name"
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                    <TextInput
                      source="requestDeliveryInfo.attentionPhone"
                      label="Attention Phone"
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                    <TextInput
                      source="requestDeliveryInfo.email"
                      label="E-Mail"
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                    <TextInput
                      source="requestDeliveryInfo.shippingAddress"
                      label="Shipping Address"
                      multiline
                      fullWidth
                      rows={3}
                      variant="outlined"
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={5}>
                    <TextInput
                      source="requestDeliveryInfo.consigneeName"
                      label="Company/Consignee Name"
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                    <TextInput
                      source="requestDeliveryInfo.consigneeAddress"
                      label="Company/Consignee Address"
                      disabled
                      fullWidth
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </>
            </Grid>
          </Grid>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.DataSource?.experience} type={ExperienceNoteType.Info} />
    </>
  );
};

const RbhRequestOrderView = props => {
  return <RequestView DataSource={props.DataSource} />;
};

export default RbhRequestOrderView;
